/* eslint-disable import/prefer-default-export */
import React from 'react';
import PropTypes from 'prop-types';

export const Submit = ({ value, className, hasError, ...rest }) => (
  // eslint-disable-next-line react/button-has-type
  <input
    type="submit"
    value={value}
    className={`btn${className ? ` btn--${className}` : ''}${
      hasError ? ' has-error' : ''
    }`}
    // eslint-disable-next-line react/jsx-props-no-spreading
    {...rest}
  />
);

Submit.propTypes = {
  value: PropTypes.string.isRequired,
  className: PropTypes.string,
  hasError: PropTypes.bool
};

Submit.defaultProps = {
  className: '',
  hasError: false
};
